import { render, staticRenderFns } from "./AddTradeProduct.vue?vue&type=template&id=3dafcdd6&"
import script from "./AddTradeProduct.vue?vue&type=script&lang=js&"
export * from "./AddTradeProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports